import { PROFILE } from '../../data/profile';
import ContourField from '../ContourField/ContourField';
import './About.css';

const CORE_TOOLS = ['C#', '.NET', 'Python', 'TypeScript', 'React', 'SQL', 'AWS'];

export default function About() {
  return (
    <section id="about" className="section about" aria-labelledby="about-title">
      {/* The same survey map as the hero, in navy: one motif, used at the start and the middle of the page */}
      <ContourField tone="dark" interactive={false} className="about-contours" />
      <div className="container about-layout">
        <h2 id="about-title" className="section-title about-title" data-reveal="title">
          <span className="title-mask"><span>About me</span></span>
        </h2>
        <div className="about-copy">
          <p className="about-lead" data-reveal>
            I started with Scratch for the Junior Cert, then got deeper into Python for the Leaving Cert.
          </p>
          <p data-reveal style={{ '--i': 1 }}>
            Today I work across interfaces, APIs, data and computer vision. I enjoy figuring out how the pieces fit together, then making them clear for the person using them.
          </p>
          <p data-reveal style={{ '--i': 2 }}>
            Based in {PROFILE.location}. Outside of code, I enjoy travelling, reading and gaming.
          </p>
          <div className="about-skill-line" data-reveal style={{ '--i': 3 }}>
            <span className="about-skill-label">Core tools</span>
            <ul>{CORE_TOOLS.map((tool) => <li key={tool}>{tool}</li>)}</ul>
          </div>
        </div>
      </div>
    </section>
  );
}
